import TabRecoveryService from "@/template-scripts";
import store from "@/store";
import router from "@/router";

let _service = null;

// Роути на яких SessionGuard активний
const GUARDED_ROUTES = ["home", "RegistrationViews"];

/**
 * Перевіряє чи поточний роут підпадає під дію SessionGuard.
 */
function isGuardedRoute() {
    const currentRoute = router.currentRoute.value;
    return GUARDED_ROUTES.includes(currentRoute.name);
}

/**
 * Скидає весь стан реєстрації та перенаправляє на головну.
 * Використовується при бездіяльності та зміні дня.
 */
async function resetAndRedirect(reason) {
    // Ігноруємо якщо юзер на адмін-панелі або інших сторінках
    if (!isGuardedRoute()) {
        console.log(`[SessionGuard] Skipped (not a guarded route): ${router.currentRoute.value.name}`);
        return;
    }

    console.log(`[SessionGuard] Reset triggered: ${reason}`);

    // Очищаємо localStorage (на випадок якщо була розпочата оплата)
    localStorage.removeItem("addEvent");
    localStorage.removeItem("setBase");
    localStorage.removeItem("sendMessageToTelegramm");

    // Скидаємо Vuex-стан реєстрації
    store.commit("registration/RESET_REGISTRATION_DATA");

    // Скидаємо dropdown
    store.commit("dropdown/RESET_DROPDOWN_DATA");

    // Якщо юзер не на головній — робимо redirect
    const currentRoute = router.currentRoute.value;
    if (currentRoute.name !== "home") {
        await router.push({ name: "home" });
    }
}

/**
 * Оновлює дані календаря (зайняті дати) без скидання форми.
 * Викликається при поверненні у вкладку після тривалої відсутності.
 */
async function refreshCalendarData() {
    if (!isGuardedRoute()) return;

    const consultantID = store.state.registration.consultantID;
    const date = store.state.registration.date;

    if (!consultantID || !date?.mounth) return;

    // Тригеримо fetchConsultants для оновлення списку
    await store.dispatch("consultants/fetchConsultants");

    console.log("[SessionGuard] Calendar data refreshed");
}

/**
 * Ініціалізує глобальний SessionGuard.
 * Викликати один раз в App.vue (mounted).
 */
export function initSessionGuard() {
    if (_service) return; // вже запущено

    _service = new TabRecoveryService({
        // Поріг для оновлення даних при поверненні у вкладку
        threshold: 5 * 60 * 1000, // 5 хвилин

        // Таймер бездіяльності — 3 години
        inactivityTimeout: 3 * 60 * 60 * 1000,

        debug: process.env.NODE_ENV !== "production",

        // Повернення у вкладку після тривалої відсутності → оновити дані
        onRecover: async ({ awayTime }) => {
            console.log(`[SessionGuard] onRecover: away ${Math.round(awayTime / 1000)}s`);
            await refreshCalendarData();
        },

        // Бездіяльність 3 год → reset + redirect
        onInactivity: () => {
            resetAndRedirect("inactivity (3 hours)");
        },

        // Змінився день → reset + redirect
        onDateChange: ({ awayTime }) => {
            console.log(`[SessionGuard] onDateChange: away ${Math.round(awayTime / 1000)}s`);
            resetAndRedirect("date changed (new day)");
        },
    });

    _service.init();
}

/**
 * Зупиняє SessionGuard.
 * Викликати в beforeUnmount App.vue.
 */
export function destroySessionGuard() {
    if (_service) {
        _service.destroy();
        _service = null;
    }
}
